import React from 'react'

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  onCheckedChange?: (checked: boolean) => void;
}

export const Checkbox: React.FC<CheckboxProps> = ({ className, onCheckedChange, onChange, ...props }) => {
  const baseClasses = 'h-4 w-4 rounded border-gray-300 text-[#3eaf99] focus:ring-[#3eaf99]'
  const classes = `${baseClasses} ${className || ''}`

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked)
    }
    if (onChange) {
      onChange(e)
    }
  }

  return (
    <input
      type="checkbox"
      className={classes}
      onChange={handleChange}
      {...props}
    />
  )
}

export default Checkbox 